import "./index.css";

import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import AppRoutes from "@/routes";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: "/api/sentry-tunnel",
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: `${import.meta.env.VITE_DEPLOYMENT_ID}::${import.meta.env.VITE_DEPLOYMENT_REVISION}`,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: (e) => {
    console.log("[sentry.init beforesend]", e);
    return e;
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRoutes />
  </StrictMode>
);
